var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"error-article"}},[_c('div',{staticClass:"error"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.linkText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }